import React from "react";

import { CopyIcon } from "@/components/ui/icons/CopyIcon";

export type CopyToClipboardProps = {
  value: string;
};
export const CopyToClipboard = (props: CopyToClipboardProps) => {
  const { value } = props;

  const handleCopyToClipBoard = () => {
    navigator.clipboard?.writeText(value);
  };

  return (
    <button
      type="button"
      data-testid="copy-to-clipboard-button"
      onClick={handleCopyToClipBoard}
      // The underline grows from the left on hover
      className="relative flex cursor-pointer items-center border-none bg-transparent p-0 text-sm font-bold text-primary-fg ring-offset-background after:absolute after:-bottom-0.5 after:left-0 after:block after:h-0.5 after:w-full after:origin-left after:scale-x-0 after:bg-primary after:transition-transform after:duration-200 after:content-[''] hover:after:scale-x-100 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <CopyIcon className="mr-2" color="currentColor" />
      Copy
    </button>
  );
};
